import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete';
import type { DisplayContextsType } from '@openx/types/targeting/targeting';
import type { TechnologyAndDevicesOption as TechnologyAndDevicesOptionType } from '@openx/types/targeting/technologyAndDevices';
import { useTranslation } from 'react-i18next';
import { useTargetingOptionDisabledState } from '../../../utils/hooks/useTargetingOptionDisabledState';
import { useTypeOptionDropdown } from './hooks/useTypeOptionDropdown';

type TypeOptionDropdownProps = {
  onChange: (type: TechnologyAndDevicesOptionType) => void;
  value: TechnologyAndDevicesOptionType;
  isNewFormat?: boolean;
  displayContext?: DisplayContextsType;
};

export const TypeOptionDropdown = ({
  onChange,
  value,
  isNewFormat = true,
  displayContext,
}: TypeOptionDropdownProps) => {
  const { t } = useTranslation();
  const { optionsKeys, getOptionLabel } = useTypeOptionDropdown(isNewFormat, displayContext);
  const { isOptionDisabled } = useTargetingOptionDisabledState();

  return (
    <AutoComplete<TechnologyAndDevicesOptionType, false, true, false>
      textFieldProps={{ label: t('Type') }}
      options={optionsKeys}
      renderOptions={{
        dataTest: 'type-option',
      }}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={option => isOptionDisabled(option)}
      textFieldReadOnly
      disableClearable
      filterOptions={option => option}
      onChange={(_, value) => onChange(value)}
      value={value}
      fullWidth
      data-test="technology-and-devices-type"
    />
  );
};
